module.exports = __webpack_public_path__ + "static/media/picture_analyze_video.c9575c5f.mp4";